// extracted by mini-css-extract-plugin
export default {"table":"viewProducts_table__J2X9t","search":"viewProducts_search__hEO31","icons":"viewProducts_icons__aUY4m"};